import * as React from "react";
import * as ReactDOM from "react-dom";
import {CommentRow, IComments, ICommentProps} from './CommentRow';
import Ajax from "../../../lib/Ajax";


interface ICommentConfigProps extends ICommentProps{
    getUrl:string
    addUrl:string
}
interface ICommentState {
    items:Array<IComments>
}

export class Comment extends React.Component<ICommentConfigProps, ICommentState>{

    constructor(props:ICommentConfigProps){
        super(props);
        this.init();
    }

    protected init():void{
        this.state = {
            items: []
        };
        var method:string = 'POST';
        if ( this.props.getUrl.indexOf('.json') > -1 ) {
            method= 'GET';
        }
        // tslint:disable-next-line:no-unused-expression
        new Ajax(this.props.getUrl, method, { eventId: this.props.eventId, toId: this.props.toId }, (data)=>{
            this.setState({
                 items: data.items
            });
        });
    }

    protected addItem(comment:string, toId:number, targetUserId:number):void{
        // save new item
        var method:string = 'POST';
        if ( this.props.getUrl.indexOf('.json') > -1 ) {
            method= 'GET';
        }
        // tslint:disable-next-line:no-unused-expression
        new Ajax(this.props.addUrl, method, {
            eventId: this.props.eventId,
            toId: toId,
            comment: comment,
            targetUserId: targetUserId
        }, (data)=>{
            if ( data.success !== undefined ) {
                var item:IComments={
                    id: data.id,
                    comment: comment,
                    toId: toId,
                    targetUserId: targetUserId,
                    fromUserId: data.userId,
                    date: data.date,
                    userImage: data.userImage,
                    userName: data.userName,
                    userInfo: data.userInfo
                };
                // add to stage
                var items = this.state.items;
                var newItems:Array<IComments> = [];
                newItems.push(item);
                for (var key in items) {
                    newItems.push(items[key]);
                }

                this.setState({
                    items: []
                }, ()=>{
                    // NOTE: react fix
                    this.setState({
                        items: newItems
                    });
                });
            }
        });
    }


    render() {
        return (
            <div className="comment_comp">
                <CommentRow
                    key="main_comment"
                    eventId={ this.props.eventId }
                    toId={ this.props.toId }
                    targetUserId={ this.props.targetUserId }
                    open={ this.props.open }
                    item={ null }
                    addItem = { (data, toId, targetUserId)=> this.addItem(data, toId, targetUserId) }
                />
                {
                    this.state.items.map((item, key)=>{
                        return<CommentRow
                                key = {key}
                                eventId={ this.props.eventId }
                                toId={ item.id }
                                targetUserId={ item.fromUserId }
                                open={ false }
                                item={ item }
                                addItem = { (data, toId, targetUserId)=> this.addItem(data, toId, targetUserId) }
                                />;
                    })
                }

            </div>
        );
    }
}

export class InitComment {
    constructor(cb?:Function) {
        var div: HTMLDivElement = document.getElementById('comment') as HTMLDivElement;
        if (div !== null) {
            var data:any = div.dataset;
            ReactDOM.render(<Comment getUrl={ data.geturl } addUrl={ data.addurl } eventId={ data.event_id } targetUserId={0} toId={0} open={true} />, div, ()=>{
                if ( cb !== undefined) {
                    cb();
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./avernus/comment/source/Comment.tsx